import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'categories_json';

const mockCategories = [
  { id: 'cat1', name: 'Drinks', description: 'Beverages and drinks' },
  { id: 'cat2', name: 'Snacks', description: 'Snack items' },
  { id: 'cat3', name: 'Dairy', description: 'Milk and dairy products' },
  { id: 'cat4', name: 'Other', description: 'Other products' },
];

function loadCategories() {
  const json = localStorage.getItem(LOCAL_KEY);
  if (json) {
    try {
      return JSON.parse(json);
    } catch {
      return mockCategories;
    }
  }
  return mockCategories;
}
function saveCategories(categories) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(categories));
}

const initialState = {
  categories: loadCategories(),
  filtered: loadCategories(),
  filters: {
    search: '',
  },
};

const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
      let filtered = state.categories;
      const { search } = state.filters;
      if (search) {
        const s = search.toLowerCase();
        filtered = filtered.filter(c => c.name.toLowerCase().includes(s) || c.description.toLowerCase().includes(s));
      }
      state.filtered = filtered;
    },
    resetFilters(state) {
      state.filters = { search: '' };
      state.filtered = state.categories;
    },
    addCategory(state, action) {
      state.categories.push({ ...action.payload, id: 'cat-' + Date.now() });
      state.filtered = state.categories;
      saveCategories(state.categories);
    },
    editCategory(state, action) {
      const idx = state.categories.findIndex(c => c.id === action.payload.id);
      if (idx !== -1) {
        state.categories[idx] = { ...action.payload };
        state.filtered = state.categories;
        saveCategories(state.categories);
      }
    },
    removeCategory(state, action) {
      state.categories = state.categories.filter(c => c.id !== action.payload);
      state.filtered = state.categories;
      saveCategories(state.categories);
    },
  },
});

export const { setFilter, resetFilters, addCategory, editCategory, removeCategory } = categorySlice.actions;
export default categorySlice.reducer; 